import { ExemptionState } from "../../models/orderItem";

export default function exemptionKeys(registrationState?: ExemptionState) {
  switch (registrationState) {
    case ExemptionState.Exempted:
      return "exemptedRegistrationInfo";
    case ExemptionState.O:
      return "possibleElectricVehicleExemption";
    case ExemptionState.P:
      return "possibleVeteranVehicleExemption";
    case ExemptionState.C:
      return "possibleMilitaryVehicleExemption";
    default:
      return undefined;
  }
}
